{
  "name": "20-(3,5,13) < 256°",
  "description": "20-tone Rational Intonation gamut, consisting of pitch classes derived from odd harmonic partials not exceeding 256° and comprising only products of primes 3, 5, and 13.",
  "scale": [
    "65/64",
    "135/128",
    "9/8",
    "75/64",
    "39/32",
    "5/4",
    "81/64",
    "169/128",
    "45/32",
    "3/2",
    "195/128",
    "25/16",
    "13/8",
    "27/16",
    "225/128",
    "117/64",
    "15/8",
    "243/128",
    "125/64",
    "2/1"
  ],
  "key_colors_mode": "manual",
  "short_description": "OddPart(3,5,13)",
  "built_in_group": "Odd Partial Pitch Class Sets",
  "key_labels": "note_names",
  "note_names": [
    "1",
    "65",
    "135",
    "9",
    "75",
    "39",
    "5",
    "81",
    "169",
    "45",
    "3",
    "195",
    "25",
    "13",
    "27",
    "225",
    "117",
    "15",
    "243",
    "125"
  ],
  "note_colors": [
    "#ffb9b9",
    "#e9d7d3",
    "#fffae5",
    "#ffffff",
    "#fef5be",
    "#e6d7fe",
    "#fffae5",
    "#ffffff",
    "#dbb3ff",
    "#fffae5",
    "#ffffff",
    "#e9d7d3",
    "#fef5be",
    "#e6d7fe",
    "#ffffff",
    "#fef5be",
    "#e6d7fe",
    "#fffae5",
    "#ffffff",
    "#ffef8a"
  ],
  "equivSteps": 20,
  "fundamental": 440,
  "reference_degree": 14,
  "center_degree": 0,
  "rSteps": 3,
  "drSteps": 1,
  "hexSize": 42,
  "rotation": -16.102113751
}
